import Component, { mixins } from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import PropertyCommons from '../commons/property.model';
import DatePick from 'vue-date-pick';
import { DATE_FORMAT, DATE_FORMAT_H, DATE_TIME_FORMAT, HTML_DATE_FORMAT } from '@/shared/date/date-utils';
import { MesEnum } from '@/shared/model/enumerations/mes-enum.model';
import { SemanaEnum } from '@/shared/model/enumerations/semana-enum.model';

@Component({
  components: {
    DatePick,
  },
})
export default class InputDateTimeComponent extends mixins(PropertyCommons) {
  public format = HTML_DATE_FORMAT;
  public displayFormat = DATE_FORMAT_H;
  public currentDate = new Date();
  public starMonthLocal: number = null;
  public starDateLocal: number = null;
  public meses = Object.values(MesEnum);
  public semana = Object.values(SemanaEnum);

  @Prop({ required: true })
  public value!: string;

  @Prop({ default: null })
  minDate: string;

  @Prop({ default: null })
  maxDate: string;

  @Prop({ default: new Date().getFullYear() })
  starDate: number;

  @Prop({ default: new Date().getMonth() })
  starMonth: number;

  @Prop({ default: false })
  limitDate: string;

  @Prop({ default: false })
  public time: boolean;

  @Watch('time', { immediate: true })
  handler(value: string) {
    if (value) {
      this.format = DATE_TIME_FORMAT;
      this.displayFormat = DATE_FORMAT_H;
    } else {
      this.format = HTML_DATE_FORMAT;
      this.displayFormat = DATE_FORMAT;
    }
  }

  get dateValue(): string {
    return this.value;
  }

  set dateValue(newValue: string) {
    this.$emit('input', newValue);
  }

  isFutureDate(date: Date): boolean {
    if (this.limitDate && !this.maxDate && !this.minDate) {
      return date > new Date();
    } else if (this.maxDate || this.minDate) {
      const minDate = this.minDate ? this.minDate : new Date(1920, 0, 1); // La fecha mínima solicitada o default
      const maxDate = this.maxDate ? this.maxDate : new Date(); // La fecha solicitada máxima o default

      const pickedDate = new Date(date);
      return pickedDate < minDate || pickedDate > maxDate;
    }
  }

  @Emit('change')
  onChange(e: string) {
    const date = new Date(e); //obtiene fecha para sacar mes y año y setearlo en startPeriod cuando ya tiene una fecha seleccionada
    this.starMonthLocal = date.getMonth();
    this.starDateLocal = date.getFullYear();
    return e;
  }
}
